import React from "react";
import { Cargo } from "../models/Cargo";

const CargoContext = React.createContext({
  selectedCargo: null as Cargo | null,
  setSelectedCargo: (cargo: React.SetStateAction<Cargo | null>) => {},
});

export default CargoContext;
